import i18next from "i18next";
import moment from "moment";
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";
import localeEn from 'antd/es/date-picker/locale/en_US';
import localeFr from 'antd/es/date-picker/locale/fr_FR';

export const changeLanguage = (language = 'en') => {
  StorageManager.set("datastakeLng", language);
  i18next.changeLanguage(language);
  moment.locale(language, language === 'fr' ? localeFr : localeEn);
}
